export default "__VITE_ASSET__CASZqH2v__"